import { TimeToGetToProps } from './TimeToGetToItem';

import TransportationWidget from './transportation-widget';
import { IInsightPreview } from 'components/widget/common/styled';
import { InsightSection, TransportationSectionType, TransportationState } from 'store/state/insightsContext';
import {
  setActiveTransportation,
  setTransportationState as setTransportationStateAction,
  setHoveredTransportationStation,
  setMobileMapType,
} from 'store/state/insightsContext/actions';
import { State } from 'store/state';
import { connect } from 'react-redux';
import { DetailPageEventCategory } from 'analytics/handlers/detailPageSectionHandlers';
import { detailPageCategorySelector } from 'store/state/selectors/analytics';
import {
  transportationHubsDataSelector,
  transportationCarouselDataSelector,
  transportationAccordionDataSelector,
  TransportationAccordionSection,
  transportationAccordionSelector,
  transportationTransitTabSelector,
  accordionItemsExist,
} from 'store/state/selectors/insights/transportation';
import {
  isCollapsedInsightsSelector,
  showInsightsCarouselSelector,
} from 'store/state/selectors/insights/insightSections';


interface AdditionalProps {
  accordionData: TransportationAccordionSection[];
  carouselData: IInsightPreview[];
  transportationHubsData: TimeToGetToProps[];
}

export interface TransportationWidgetProps extends AdditionalProps {
  setTransportationState: (state: Partial<TransportationState>) => void;
  activeAccordion: TransportationSectionType;
  transitTab: TransportationSectionType;
  setActiveTransportationId: (id: string) => void;
  setHoveredStation: (name: string) => void;
  eventCategory: DetailPageEventCategory;
  onSeeOnMapClick: () => void;
  accordionItemsExist: boolean;
  isCollapsed: boolean;
  showCarousel: boolean;
}

const mapStateToProps = (state: State) => ({
  accordionData: transportationAccordionDataSelector(state),
  carouselData: transportationCarouselDataSelector(state),
  transportationHubsData: transportationHubsDataSelector(state),
  activeAccordion: transportationAccordionSelector(state),
  transitTab: transportationTransitTabSelector(state),
  eventCategory: detailPageCategorySelector(state),
  accordionItemsExist: accordionItemsExist(state),
  isCollapsed: isCollapsedInsightsSelector(state),
  showCarousel: showInsightsCarouselSelector(state),
});

const mapDispatchToprops = {
  setActiveTransportationId: setActiveTransportation,
  setTransportationState: setTransportationStateAction,
  setHoveredStation: setHoveredTransportationStation,
  onSeeOnMapClick: () => setMobileMapType(InsightSection.Transportation),
};

export default connect(mapStateToProps, mapDispatchToprops)(TransportationWidget);
